import { useSyncExternalStore } from "react";

// What the `[@media(pointer:coarse)]` classes read: a touch screen
const QUERY = "(pointer: coarse)";

const subscribe = (onChange: () => void) => {
  const media = window.matchMedia(QUERY);
  media.addEventListener("change", onChange);
  return () => media.removeEventListener("change", onChange);
};

/** Whether the primary pointer is coarse (a touch screen), so menu rows are 44 tall. */
export const useCoarsePointer = () =>
  useSyncExternalStore(
    subscribe,
    () => window.matchMedia(QUERY).matches,
    () => false,
  );
